export default __webpack_public_path__ + "9878c7722b60e8d379b47a5778b8f07b.jpg";